import { defineAsyncComponent } from 'vue'
import './font.css'
import './tokens.css'
import './overrides.css'
import './legacy-primitives.css'
import { assets } from './assets'
import { icons } from './icons'

export const components = Object.freeze({
  'landing-page': defineAsyncComponent(() => import('./components/ArvandLandingPage.vue')),
  'home-dashboard': defineAsyncComponent(() => import('./components/ArvandHomeDashboard.vue')),
  'user-sidebar-transfer-actions': defineAsyncComponent(() =>
    import('./components/ArvandUserSidebarTransferActions.vue')
  )
})

export const copy = Object.freeze({
  profileNavigationTitle: 'settingsTitle',
  profileNavigationLink: 'settingsLink'
})

export const options = Object.freeze({
  profilePageSummary: false,
  adminReportsLandingNav: 'financial-report'
})

export { assets }
export { icons }
